import Swiper from "../../assets/.npm/node_modules/swiper";
//import Navigation from "../../assets/.npm/node_modules/swiper/modules/navigation.min.mjs";
import Pagination from "../../assets/.npm/node_modules/swiper/modules/pagination.min.mjs";

export default () => {
  let treatmentSwiper = new Swiper(".treatmentSwiper", {
    modules: [Pagination],
    loop: true,
    spaceBetween: 30,
    centeredSlides: true,
    pagination: {
        el: ".treatment-pagination",
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          centeredSlides: false,
        },
    
        576: {
          slidesPerView: 1.8,
          centeredSlides: true,
        },
    
        992: {
          slidesPerView: 2.8, 
          centeredSlides: true,
        }
      }
  });

  jQuery(document).on('lity:ready', function (event, instance) {

    const popup = instance.element();
    const trigger = instance.opener();

    // chỉ zoom đúng slider này
    if(!trigger.hasClass('zoom-trigger')) return;

    popup.addClass('zoom-popup');

    const img = popup.find('.lity-content img')[0];
    if(!img) return;

    // tránh bind lặp
    if(img.dataset.bound) return;
    img.dataset.bound = 1;

    img.addEventListener('mousemove', function(e){

      const r = img.getBoundingClientRect();

      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;

      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = 'scale(2)';
    });

    img.addEventListener('mouseleave', function(){
      img.style.transform = 'scale(1)';
      img.style.transformOrigin = 'center center';
    });

  });
}
  
